<template>
  <div class="form-research">
    <page-title v-if="!isOnlineResults && !isUnlogged">
      {{$t('_my_research')}}
    </page-title>

    <form-base class="research" :type="type" :form-data="value"
               :default-submit-button="false" :submit-callbacks="submitCallbacks"
    >
      <b-row class="justify-content-center">
        <b-col md="6">
          <favorite-selection v-if="isPrelogged && displayFavorites"
                              v-model="value.favorite"
                              :favorite-locations="favoriteLocations"
                              :unlogged-infos="unloggedInfos"
                              :is-prelogged="true"
          />

          <locationAutocomplete v-else class="destination"
                                label="home.form.destination.label"
                                placeholder="home.form.destination.placeholder"
                                v-model="value.destination"
                                ref="destination" :required="false"
                                :is-unlogged="!isUnlogged"
          />
        </b-col>

        <b-col md="6">
          <locationAutocomplete v-if="isPrelogged" class="destination"
                                label="home.form.destination.preloggedLabel"
                                placeholder="home.form.destination.placeholder"
                                v-model="value.destination"
                                ref="destination"
                                :is-unlogged="!isUnlogged"
                                :required="false"
          />

          <bedrooms-repartition v-else class="bedrooms" ref="bedrooms"
                                label="home.form.bedrooms.label"
                                v-model="value.bedrooms"
                                :company-only-one="onlyOne"
                                :is-unlogged="!isUnlogged"
                                @single="singleChanged"
                                @double="doubleChanged"
          />
        </b-col>

        <!-- utilisation d'un display: flex pour le composant date-range -->
        <b-col md="12">
          <date-range class="dates" v-model="value.dates" />
        </b-col>

        <b-col v-if="displayFavorites" md="6">
          <favorite-selection v-if="!isPrelogged" v-model="value.favorite"
                              :favorite-locations="favoriteLocations"
                              :unlogged-infos="unloggedInfos"
          />
        </b-col>
      </b-row>

      <div v-if="displaySubmitButton" class="submit-row no-underline">
        <b-row class="justify-content-around">
          <submit-button class="submitForm modify width-md" name="modify"
                         :text="$t(submitButtonText)"
          />

          <input v-if="this.offlineAvailable" type="button" name="with-agent"
                 :value="$t('home.offline.offline')"
                 class="btn orange-white submitForm offline with-agent mb-3 width-md"
                 @click="onClickOffline"
          />
        </b-row>
      </div>
    </form-base>
  </div><!--  form-research -->
</template>

<script>
import pageTitle from '@/components/frontoffice/pageTitle'
import formBase from '@/components/frontoffice/form/base'
import locationAutocomplete from '@/components/frontoffice/form/locationAutocomplete'
import favoriteSelection from '@/components/frontoffice/form/favoriteSelection'
import bedroomsRepartition from '@/components/frontoffice/form/bedroomsRepartition'
import dateInput from '@/components/frontoffice/form/baseInput/date'
import dateRange from '@/components/frontoffice/form/baseInput/dateRange'
import dateRangeMixin from '@/components/frontoffice/mixins/dateRange'
import submitButton from '@/components/frontoffice/form/baseInput/submit'
import CommonApi from '@/api/commonApi'

export default {
  components: {
    pageTitle,
    formBase,
    locationAutocomplete,
    favoriteSelection,
    bedroomsRepartition,
    dateInput,
    dateRange,
    submitButton
  },

  mixins: [dateRangeMixin],

  props: {
    displaySubmitButton: {
      type: Boolean,
      default: true
    },
    value: {
      type: Object,
      required: true
    },
    type: {
      type: String,
      default: 'offline'
    },
    submitCallbacks: Function,
    isUnlogged: {
      type: Boolean,
      default: false
    },
    isPrelogged: {
      type: Boolean,
      default: false
    },
    unloggedInfos: Object,
    companyOnlyOne: {
      default: false
    },
    submitButtonText: {
      type: String,
      default: '_modify'
    }
  },

  data () {
    return {
      commonApi: new CommonApi(),
      displayFavorites: false,
      favoriteLocations: [],
      onlyOne: false,
      isOnlineResults: false,
      currentPage: this.$route.name,
      offlineAvailable: true
    }
  },

  created () {
    let uniqueChain = null

    this.offlineAvailable = this.$store.getters['security/user'].offline

    if (!this.isUnlogged) {
      this.onlyOne = this.companyOnlyOne
    } else {
      uniqueChain = this.unloggedInfos.companyUniqueChain
      this.onlyOne = this.unloggedInfos.onlyOne
    }

    if (this.currentPage === 'online_results') {
      this.isOnlineResults = true
    }

    this.commonApi.companyFavoriteLocations(uniqueChain)
      .then(response => {
        this.favoriteLocations = response.data.data
        this.displayFavorites = this.favoriteLocations.length > 0
      })
  },

  methods: {
    onClickOffline () {
      this.$router.push({ name: 'offline_home' })
    },

    singleChanged (val) {
      this.$emit('single', val)
    },

    doubleChanged (val) {
      this.$emit('double', val)
    }
  }
}
</script>
<style scoped>
.submit-row .offline {
  text-transform: none;
}
</style>

<style scoped>
.submit-row .offline {
  text-transform: none;
}

.submit-row .modify{
  text-transform: uppercase;
}
</style>
